import { render, staticRenderFns } from "./SrFundingSourceCreate.vue?vue&type=template&id=068e6482&"
import script from "./SrFundingSourceCreate.vue?vue&type=script&lang=js&"
export * from "./SrFundingSourceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports